import React, { useEffect, useState } from 'react'
import { CircleCheckIcon } from '../../../../Icons/CircleCheckIcon'
import { StyledCircleCheckIconWrapper } from './StyledCircleCheckIconWrapper'
import { useTranslation } from 'react-i18next'
import { isEmptyGuid } from '../../../../../utils/emptyGuid';

const VariousCheck = ({ baseData }) => {
    const [isValid, setIsValid] = useState(false)
    const { t } = useTranslation()

    useEffect(() => {
        if (!!baseData.contingentsCostperItem || !!baseData.price?.value || !isEmptyGuid(baseData.class?.unit?.id)) {
            setIsValid(true)
        } else {
            setIsValid(false)
        }
    }, [baseData])

    return (
        <>
            <StyledCircleCheckIconWrapper>
                <CircleCheckIcon variant={isValid ? 'optional' : 'none'} />
            </StyledCircleCheckIconWrapper>
            <span>{t('articleAdmin:variousData')}</span>
        </>
    )
}

export default VariousCheck